export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('expires_at');

  sessionStorage.removeItem('token');
  sessionStorage.removeItem('expires_at');
};
